/* Package JSON Import will be here */
import React, { useEffect, useState, useRef } from "react";
import { Button, Modal, Input, Row, Col, Typography } from "antd";
import { getTranslate } from "react-localize-redux";
import { useSelector } from 'react-redux';
import { Badge } from 'antd';
/* Package JSON Import will be here */

/* Project Import will be here */
import { errorToast } from "utilities/utils";
import Constants from "utilities/appConstants";
/* Project Import will be here */

/* Const,Let & Var will be here */
const { Text } = Typography;
/* Const,Let & Var will be here */

const OrderQtyModal = (props) => {
    const inputRef = useRef(null);
    const sharedProps = {
        ref: inputRef
    };
    const countType = props.pageType === Constants.PIECE_QTY ? "count" : "case_count";

    const [selectedQty, setQty] = useState(props.orders.data[props.product.ProductId][countType]);

    const { translate } = useSelector((state) => ({
        translate: getTranslate(state.locale)
    }));

    useEffect(() => {
        inputRef.current.focus({
            cursor: 'end',
        });
    });

    useEffect(() => {
        setQty(props.orders.data[props.product.ProductId][countType])
    }, [props.orders]);

    const onChange = e => {
        const targetValue = e.target.value;

        /* Only allow number on the text field */
        if (/^[0-9]*$/.test(targetValue)) {
            if (targetValue === "0")
                setQty(targetValue);
            else
                setQty(targetValue.replace(/^0+/, ''));
        }
    };

    const CheckQtyChange = () => {
        if (/^[0-9]*$/.test(selectedQty)) {
            if (props.orders.data[props.product.ProductId][countType] === parseInt(selectedQty, 10))
                return true;
            else
                return false;
        }
        else
            return true;
    }

    const checkForMinOrderBeforeSubmit = () => {
        if (/^[0-9]*$/.test(selectedQty)) {

            let totalQty = 0;
            const selectedQtyInteger = parseInt(selectedQty, 10);
            if ((props.appSettings.isEnableMinOrderQty && props.product.MinORDQty !== 0) && selectedQtyInteger > 0) {
                /* Piece logic */
                if (props.pageType === Constants.PIECE_QTY) {
                    totalQty = selectedQtyInteger + (props.product.ConversionQty * props.orders.data[props.product.ProductId]["case_count"]);

                    if (totalQty >= props.product.MinORDQty && (totalQty <= props.product.MaxORDQty || props.product.MaxORDQty === 0)) {
                        /* Check for round */
                        if (selectedQtyInteger % props.product.RoundORDQty === 0) {
                            submitQty();
                        }
                        else
                            errorToast({ content: translate("order.minOrderQty.validationMsg", { count: props.product.RoundORDQty }) });
                    }
                    else
                        errorToast({ content: translate("order.minOrderQty.validationMsg", { count: props.product.RoundORDQty }) });
                }

                /* case logic */
                else if (props.pageType === Constants.CASE_QTY) {
                    totalQty = ((selectedQtyInteger * props.product.ConversionQty) + props.orders.data[props.product.ProductId]["count"]);

                    if (totalQty >= props.product.MinORDQty && (totalQty <= props.product.MaxORDQty || props.product.MaxORDQty === 0)) {
                        submitQty();
                    }
                    else {
                        errorToast({ content: translate("order.minOrderQty.validationMsg", { count: props.product.MinORDQty }) });
                    }
                }
            }
            else {
                submitQty();
            }
        }
        else {
            errorToast({ content: translate("order.bulkOrderUpload.validationMsg") });
        }
    }

    const submitQty = () => {
        props.onQtyChanged(selectedQty);
        props.closeOrderQtyModal();
    }

    return (
        <React.Fragment>
            <Modal
                visible={props.isShowOrderQtyModal}
                centered
                title={translate("order.minOrderQty.qtyModalLabel")}
                closeIcon={<i className="fa fa-times-circle fa-lg modal-close-button-icon" aria-hidden="true"></i>}
                onCancel={props.closeOrderQtyModal}
                className="order-qty-modal"
                width={450}
                maskClosable={false}
                footer={[
                    <Button
                        onClick={props.closeOrderQtyModal}
                        key="cancel"
                        shape="round"
                        size="large"
                    >
                        {translate("common.buttons.cancel")}
                    </Button>,
                    <Button
                        key="ok"
                        onClick={checkForMinOrderBeforeSubmit}
                        type="primary"
                        shape="round"
                        size="large"
                        disabled={CheckQtyChange()}
                    >
                        {translate("common.buttons.ok")}
                    </Button>
                ]}
            >
                <div className="p-1 text-center">
                    <Text>{translate("products.productLabel.enterQtyProductText")} - {<Text strong>{props.product.ProductName}</Text>}</Text>
                </div>

                <Row justify="center" className="p-2">
                    <Col span={5} className="text-center pt-3">
                        <Text>{translate(props.pageType === Constants.PIECE_QTY ? "products.productLabel.piece" : "products.productLabel.case")} : </Text>
                    </Col>
                    <Col span={10}>
                        <Input
                            className="round-radius text-center"
                            inputMode="numeric"
                            maxLength={4}
                            {...sharedProps}
                            onChange={onChange}
                            value={selectedQty}
                            size="large"
                        />
                    </Col>
                </Row>
                {(props.appSettings.isEnableMinOrderQty && props.pageType === Constants.PIECE_QTY && props.product.MinORDQty > 0) &&
                    <Row className="text-center">
                        <Col span={24}>
                            <p>
                                <Badge color="orange" />
                                {translate("products.productLabel.minQty")} : {props.product.MinORDQty}
                            </p>
                        </Col>
                    </Row>
                }

            </Modal>
        </React.Fragment>
    );
};

export default OrderQtyModal;